<template>
  <v-container>
    <row-header action="back" :msg="msgRowHeader"></row-header>

    <v-row dense>
      <v-col>
        <v-form
            ref="form"
            v-model="valid"
        >
          <v-card>
            <bank-form-component :bank_model="bank_model" update="1" />
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  :disabled="!valid"
                  color="success"
                  @click="saveData"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>

    <v-overlay
        :absolute="absolute"
        :value="overlay"
    >
      <v-card color="white">
        <v-card-text>
          <overlay-img></overlay-img>
        </v-card-text>
      </v-card>
    </v-overlay>

  </v-container>
</template>

<script>
import RowHeader from "../../../components/content/RowHeader";
import OverlayImg from "../../../components/content/OverlayImg";
import BankFormComponent from '../../../components/page/banks/BankFormComponent';
import { PutRequest, GetRequest } from "../../../store/services/users";
import { BankData } from "../../../store/services/BankModel";

export default {
  components: {
    RowHeader,
    OverlayImg,
    BankFormComponent,
  },
  data: () => ({
    msgRowHeader: {newUser: 'Back', newMsg: 'Update Merchant'},
    valid: true,
    absolute: false,
    overlay: false,
    bank_model: new BankData(),
  }),
  async mounted() {
    console.log('merchant update view');
    if (this.$store.getters.isLoggedIn) {
      await this.getBankData();
    }
  },
  methods: {
    async getBankData() {
      await this.$store.dispatch('req_data')
      this.overlay = this.$store.getters.isLoading;
      try {
        const response = await GetRequest('banks/' + this.$route.params._id);
        delete response.data._id;
        delete response.data.created_at;
        delete response.data.created_by;
        delete response.data.updated_at;
        delete response.data.updated_by;
        delete response.data.__v
        this.bank_model = response.data;
        await this.$store.dispatch('req_success');
        this.overlay = this.$store.getters.isLoading;
      } catch (e) {
        await this.$store.dispatch('req_failed');
        this.overlay = this.$store.getters.isLoading;
        alert('Get user data failed ' + e.message);
      }
    },
    async saveData() {
      await this.$store.dispatch('req_data')
      this.overlay = this.$store.getters.isLoading;
      try {
        const response = await PutRequest('banks/' + this.$route.params._id, this.bank_model);
        await this.$store.dispatch('req_success');
        this.overlay = this.$store.getters.isLoading;
        if (response.data && response.message === 'updated') {
          alert('success to updated data');
          await this.$router.push({name: 'BankList'});
        } else {
          alert('failed to updated data');
        }
      } catch (e) {
        await this.$store.dispatch('req_failed');
        this.overlay = this.$store.getters.isLoading;
        alert('Get user data failed ' + e.message);
      }
    },
  }
}
</script>

<style scoped>

</style>
